import React, { useState, useEffect, useRef } from 'react';

const useInterval = (callback, delay, autostart) => {
  const savedCallback = useRef();
  // 0 is not playing
  // non-zero is playing
  // we can't use booleans here, because we want to be able to restart the interval
  const [isPlaying, setIsPlaying] = useState(autostart ? 1 : 0);

  // Remember the latest callback.
  useEffect(
    () => {
      savedCallback.current = callback;
    },
    [callback]
  );

  // Set up the interval.
  useEffect(
    () => {
      const tick = () => {
        savedCallback.current();
      };
      if (isPlaying) {
        const interval = setInterval(tick, delay);
        return () => clearInterval(interval);
      }
    },
    [isPlaying]
  );

  const play = () => {
    setIsPlaying(1);
  };
  const pause = () => {
    setIsPlaying(0);
  };
  const toggle = () => {
    setIsPlaying(!isPlaying);
  };
  const restart = () => {
    if (isPlaying) {
      setIsPlaying(-isPlaying);
    } else {
      setIsPlaying(1);
    }
  };

  return { isPlaying: !!isPlaying, pause, play, toggle, restart };
};

export default useInterval;
